// Identity scope for offline read caches: the same URL cached by the store's
// session must never be served to the super-admin session (or another tenant)
// in the same browser when a request times out.
function _tokenOf(config) {
  let tok = "";
  try {
    const h = config?.headers;
    const raw = h ? (typeof h.get === "function" ? h.get("Authorization") : (h.Authorization || h.authorization)) : "";
    tok = String(raw || "").replace(/^Bearer\s+/i, "");
  } catch { /* ignore */ }
  if (!tok) {
    try { tok = sessionStorage.getItem("token") || localStorage.getItem("token") || localStorage.getItem("pos_token") || ""; } catch { /* ignore */ }
  }
  return tok;
}

export function cacheScope(config) {
  const tok = _tokenOf(config);
  if (!tok) return "pub";
  try {
    const p = JSON.parse(atob(tok.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (p.tenant_id) return `t:${p.tenant_id}`;
    return `u:${p.user_id || p.sub || "super"}`;
  } catch { return "pub"; }
}

export const scopedKey = (config, key) => `${cacheScope(config)}|${key}`;
